import React, { Component } from 'react';

import "./Promo.image.scss"

import json from "../../api/data.json"
import playIcon from "../../assets/images/mobile/play.png"
class Promo extends Component {
  constructor() {
    super();
    this.state = {
      imageFull: {
        image: {
          backgroundImage: "url(" + (window.screen.width <= 768 ? json.promo.mobile_imageURL : json.promo.imageURL) + ")"
        },
        play: {
          backgroundImage: "url(" + playIcon + ")"
        }
      }
    }
  }
  addStyle(u) {
    var s = document.createElement("link");
    s.rel = "stylesheet";
    s.href = u;
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
  }
  addScript(u) {
    var s = document.createElement("script");
    s.type = "text/javascript";
    s.async = true;
    s.src = u;
    var x = document.getElementsByTagName('head')[0];
    x.appendChild(s);
  }
  componentDidMount() {
    //this.addScript("https://player.ynet.co.il/fp74/flowplayer.min.js");
    this.addStyle("https://player.ynet.co.il/fp74/skin/skin.css");
  }
  render() {
    return (
      <section className="section section-image">
        <div className="padding">
        <div className="vidcontainer">
          <video autoPlay="true" muted="true" controls="controls" loop="true">
            <source type="video/mp4" src="https://mediadownload.ynet.co.il/cdnwiz/1217/281217_1342_menoriot_SAQUj5h0_1600.mp4"></source>
          </video>
          </div>
        </div>
        {
          /*
        }
        <div style={this.state.imageFull.image} className="imagefull">
        <img className="behind" alt="" title="" src={json.promo.imageURL} />
          {
          // <div style={this.state.imageFull.play} className="playicon"></div>
          }
        </div>
        */
        }
      </section>
    );
  }
}

export default Promo;



// WEBPACK FOOTER //
// ./src/components/Promo-Image/Promo.image.js